const API_CALL = "serviceOrder/API_CALL";
const RESET_SERVICE_ORDER = "serviceOrder/RESET_SERVICE_ORDER";
const RESET_SERVICE_ORDER_DO = "serviceOrder/RESET_SERVICE_ORDER_DO";
const SEND_SERVICE_REQUEST = "serviceOrder/SEND_SERVICE_REQUEST";
const SEND_SERVICE_REQUEST_STANDARD =
  "serviceOrder/SEND_SERVICE_REQUEST_STANDARD";
  const SEND_SERVICE_REQUEST_PERSONALIZADO =
  "serviceOrder/SEND_SERVICE_REQUEST_PERSONALIZADO";
const SEND_SERVICE_REQUEST_UPLOAD = "serviceOrder/SEND_SERVICE_REQUEST_UPLOAD";
const SEND_SERVICE_REQUEST_PUTARCHIVO =
  "serviceOrder/SEND_SERVICE_REQUEST_PUTARCHIVO";
const UPDATE_SERVICE_ORDER_LIST = "serviceOrder/UPDATE_SERVICE_ORDER_LIST";
const EDIT_SERVICE_ORDER = "serviceOrder/EDIT_SERVICE_ORDER";
const EDIT_SERVICE_ORDER_DO = "serviceOrder/EDIT_SERVICE_ORDER_DO";
const CREATE_SERVICE_REQUEST = "serviceOrder/CREATE_SERVICE_REQUEST";
const DELETE_SERVICE_ORDER = "serviceOrder/DELETE_SERVICE_ORDER";
const DELETE_SERVICE_ORDER_DO = "serviceOrder/DELETE_SERVICE_ORDER_DO";
const GET_CUSTOMER_BY_CUIT = "serviceOrder/GET_CUSTOMER_BY_CUIT";
const GET_QUERY = "serviceOrder/GET_QUERY";
const GET_ENABLED_PLACES = "serviceOrder/GET_ENABLED_PLACES";

export default {
  API_CALL,
  RESET_SERVICE_ORDER,
  RESET_SERVICE_ORDER_DO,
  SEND_SERVICE_REQUEST,
  SEND_SERVICE_REQUEST_UPLOAD,
  SEND_SERVICE_REQUEST_PUTARCHIVO,
  UPDATE_SERVICE_ORDER_LIST,
  EDIT_SERVICE_ORDER,
  EDIT_SERVICE_ORDER_DO,
  CREATE_SERVICE_REQUEST,
  DELETE_SERVICE_ORDER,
  DELETE_SERVICE_ORDER_DO,
  GET_CUSTOMER_BY_CUIT,
  GET_QUERY,
  GET_ENABLED_PLACES,
  SEND_SERVICE_REQUEST_STANDARD,
  SEND_SERVICE_REQUEST_PERSONALIZADO,
};
